import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Tax, TaxCreate, TaxFilter } from '../data/tax';

export function createTaxService(client: AxiosInstance) {
  return createCrudService<Tax, TaxCreate, TaxFilter>(
    client,
    '/Tax',
    'taxId',
  );
}

export type TaxService = CrudService<Tax, TaxCreate, TaxFilter>;
